import { Box, Container, Flex, Text } from "@radix-ui/themes";
import { useI18n } from "@/i18n";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { ThemeToggle } from "./ThemeToggle";

export function Header() {
  const { t } = useI18n();

  return (
    <Box asChild className="rk-header">
      <header>
        <Container size="3">
          <Flex align="center" justify="between" px={{ initial: "4", sm: "6" }} py="3" gap="4">
            <Flex direction="column" gap="0" className="rk-wordmark">
              <Text as="div" className="rk-wordmark-title">
                {t("appName")}
              </Text>
              <Text as="div" size="1" color="gray" className="rk-tagline">
                {t("tagline")}
              </Text>
            </Flex>
            <Flex align="center" gap="2">
              <LanguageSwitcher />
              <ThemeToggle />
            </Flex>
          </Flex>
        </Container>
      </header>
    </Box>
  );
}
